import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  const whatsappNumber = "+503 7842 4212"; // Replace with actual WhatsApp number
  const whatsappMessage = encodeURIComponent("Hola Dr. Moisés, me interesa recibir mentoría pastoral. ¿Podríamos agendar una consulta?");
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace('+', '')}?text=${whatsappMessage}`;

  return (
    <section id="contacto" className="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h2 className="section-title">Agenda tu Consulta</h2>
            <p className="contact-description">
              Da el primer paso hacia un ministerio más sólido y fructífero.
              Contáctame directamente por WhatsApp para agendar una consulta personal donde podrás compartir tus desafíos
              y recibir orientación pastoral especializada.
            </p>

            <div className="contact-benefits">
              <div className="benefit-item">
                <span
                  className="benefit-icon"
                  dangerouslySetInnerHTML={{
                    __html: `<lord-icon
                      src="https://cdn.lordicon.com/ncdmfugz.json"
                      trigger="hover"
                      colors="primary:#2c5282,secondary:#dc2626"
                      style="width:28px;height:28px">
                    </lord-icon>`
                  }}
                />
                <div>
                  <h4>Espacio Confidencial</h4>
                  <p>Un ambiente seguro para compartir tus inquietudes ministeriales</p>
                </div>
              </div>
              <div className="benefit-item">
                <span
                  className="benefit-icon"
                  dangerouslySetInnerHTML={{
                    __html: `<lord-icon
                      src="https://cdn.lordicon.com/faoksnwp.json"
                      trigger="hover"
                      colors="primary:#2c5282,secondary:#dc2626"
                      style="width:28px;height:28px">
                    </lord-icon>`
                  }}
                />
                <div>
                  <h4>Consejo Personalizado</h4>
                  <p>Un espacio para ser escuchado</p>
                </div>
              </div>
              <div className="benefit-item">
                <span
                  className="benefit-icon"
                  dangerouslySetInnerHTML={{
                    __html: `<lord-icon
                      src="https://cdn.lordicon.com/rqeluyar.json"
                      trigger="hover"
                      colors="primary:#dc2626,secondary:#f59e0b"
                      style="width:28px;height:28px">
                    </lord-icon>`
                  }}
                />
                <div>
                  <h4>Amor Pastoral</h4>
                  <p>Cuidado genuino por tu bienestar y crecimiento ministerial</p>
                </div>
              </div>
            </div>
          </div>

          <div className="whatsapp-contact">
            <div className="whatsapp-card">
              <div className="whatsapp-icon">
                <span
                  dangerouslySetInnerHTML={{
                    __html: `<lord-icon
                      src="https://cdn.lordicon.com/dnphlhar.json"
                      trigger="hover"
                      colors="primary:#25D366,secondary:#128C7E"
                      style="width:60px;height:60px">
                    </lord-icon>`
                  }}
                />
              </div>
              <h3>Contáctame por WhatsApp</h3>
              <p className="whatsapp-number">{whatsappNumber}</p>
              <div className="contact-pricing">
                <p className="contact-price-label">Ofrenda Voluntaria</p>
              </div>
              <p className="whatsapp-description">
                Envíame un mensaje para agendar tu consulta de mentoría pastoral personalizada.
              </p>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-button"
              >
                <span
                  className="whatsapp-icon-btn"
                  dangerouslySetInnerHTML={{
                    __html: `<lord-icon
                      src="https://cdn.lordicon.com/ncdmfugz.json"
                      trigger="hover"
                      colors="primary:#ffffff,secondary:#ffffff"
                      style="width:20px;height:20px">
                    </lord-icon>`
                  }}
                />
                Escribir por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;